import classNames from 'classnames';

import { thousandSeparated } from 'shared/util/formatting';

import type { HotelOffer, RoomWithPeople } from '@/interfaces';
import { mapHotelRoom, mapInclusions } from '../../../../utils';
import { BookingLoginBoundary } from '@/components/bookingLoginBoundary/BookingLoginBoundary';

interface Props {
    offer: HotelOffer;
    rooms: readonly RoomWithPeople[];
    nights: number;
    isDirect?: boolean;
}

export const HotelOfferCard = ({ offer, rooms, nights, isDirect }: Props) => (
    <div
        className={classNames('ads__unit compact u-float-left u-display-inline-block u-fit-height u-ma8', {
            'u-bg-ice direct': isDirect,
        })}>
        <div className="u-float-right">
            {offer.inclusions.includes('Frokost inkludert') ? <i className={'icon icon--breakfast-included u-pl8'} /> : null}
            {offer.inclusions.includes('Ingen måltider') ? <i className={'icon icon--breakfast-not-included u-pl8'} /> : null}
        </div>
        {mapHotelRoom(offer.id, offer.rooms, 'two-line-ellipsis u-ml8--gt768')}
        <ul className="u-d1 u-pl16 u-pt8 inclusions u-ml8--gt768 u-position-absolute">
            {mapInclusions(
                offer.id,
                (isDirect === true ? ['Bestill direkte fra hotellet'] : []).concat(offer.inclusions),
                offer.hasFreeCancellation,
                3,
            )}
        </ul>
        <h3 className="u-position-absolute u-pt4 price u-t4 u-ml8--gt768">
            {thousandSeparated(Math.round(offer.totalRate))} kr
            <span className="u-d1 u-ml8 u-stone">
                for {nights} {nights === 1 ? 'natt' : 'netter'}
            </span>
        </h3>
        <BookingLoginBoundary
            offer={offer}
            rooms={rooms}
            trackingPage="hotel-page"
            buttonClass="button button--cta button--order-hotel u-position-absolute"
            buttonText={offer.integratedBooking ? 'Book nå' : 'Vis tilbud'}
        />
    </div>
);
